import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { ADMIN_GRADIENTS } from './glassTokens';

/**
 * EmptyState — glass placeholder for zero-result table rows and empty sections.
 *
 * Props:
 *   icon        — MUI icon element
 *   iconIndex   — 0-3 gradient index
 *   title       string
 *   description string
 *   action      node   — optional CTA button
 */
const ICON_GRADIENTS = [
  ADMIN_GRADIENTS.accentShort,
  'linear-gradient(135deg, #8B5CF6 0%, #22D3EE 100%)',
  ADMIN_GRADIENTS.success,
  'linear-gradient(135deg, #F59E0B 0%, #EF4444 100%)',
];

export default function EmptyState({ icon, iconIndex = 0, title = 'Nothing here yet', description, action }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const grad = ICON_GRADIENTS[iconIndex % ICON_GRADIENTS.length];

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
        px: 3,
        textAlign: 'center',
      }}
    >
      {icon && (
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: '16px',
            background: grad,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            mb: 2.5,
            opacity: 0.85,
            boxShadow: '0 8px 24px rgba(99,102,241,0.25)',
          }}
        >
          {icon}
        </Box>
      )}
      <Typography
        variant="h6"
        sx={{
          fontWeight: 700,
          letterSpacing: '-0.01em',
          color: isDark ? 'rgba(255,255,255,0.7)' : 'rgba(15,23,42,0.7)',
          mb: 0.75,
        }}
      >
        {title}
      </Typography>
      {description && (
        <Typography
          variant="body2"
          sx={{
            color: isDark ? 'rgba(255,255,255,0.4)' : 'rgba(15,23,42,0.45)',
            maxWidth: 360,
            mb: action ? 2.5 : 0,
          }}
        >
          {description}
        </Typography>
      )}
      {action}
    </Box>
  );
}
